export default __webpack_public_path__ + "static/media/platinum.8e27154d.svg";